import ApiDefined from '@appInterfaces/general.types';
import { IDepositWallet } from '../DepositQrCode/IDepositQrCode';
import { History } from 'history';
import { IBankAccountProperties } from '../WithdrawAmount/IWithdrawAmount';

export default interface IDepositForm {
  currency: string;
  bankAccounts: IBankAccountProperties[];
  updateBankAccounts: (data: IBankAccountProperties) => void;
  history: History;
  bankFormAddressDataAvailable: boolean;
  countryOfResidence: string;
  fiatRestrictedCountries: string[];
}

export type TDepositState = {
  step: EState;
  stepLoading: boolean;
};

export enum EState {
  mainCurrencyDeposit = 'mainCurrencyDeposit',
  cryptoQrDeposit = 'cryptoQrDeposit',
  depositFiatCurrency = 'depositFiatCurrency',
}

export interface IUseDepositState {
  values: {
    selectedCoin: string | undefined;
    buttonStepHidden: {
      crypto: boolean;
      usdSwift: boolean;
    };
    wallets: ApiDefined<IDepositWallet[]>;
    bic_swift?: string;
    account_number?: string;
    bankStatement?: File;
  };
  errors: {
    account_number?: string;
    bic_swift_async?: string;
    bic_swift_external?: string;
    bic_swift?: string;
    initial?: string;
  };
}

export interface IUseDepositForm {
  values: IUseDepositState['values'];
  errors: IUseDepositState['errors'];
  dispatch: React.Dispatch<object>;
}
